
window.addEventListener("DOMContentLoaded", (event) => {
  // add to cart mobile
  let mobileAtc = document.querySelector(".atc--mobile");
  let qtyBox = document.querySelector(".qty-mobile");
  let mobileInput = document.querySelector("#Quantity-mobile");

  qtyBox?.addEventListener("click", function (e) {
    let plus = e.target.closest(".qty-mobile .js-qty__adjust--plus-mobile");
    if (!plus) return;
    mobileInput.value = Number(mobileInput.value) + 1;
  });
  qtyBox?.addEventListener("click", function (e) {
    let minus = e.target.closest(".qty-mobile .js-qty__adjust--minus-mobile");
    if (!minus) return;
    mobileInput.value =
      Number(mobileInput.value) != 1 ? Number(mobileInput.value) - 1 : 1;
  });

  mobileAtc?.addEventListener("click", function () {
    let qty = mobileInput.value;
    let variantSelected = document.querySelector("form select").value;

    let formData = {
      items: [
        {
          quantity: qty,
          id: variantSelected,
        },
      ],
    };

    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        this.textContent = "adding...";
        return response.json();
      })
      .then((product) => {
        this.textContent = "Added to cart";
        setTimeout(function () {
          mobileAtc.textContent = "Add to cart";
        }, 2000);
        document.dispatchEvent(new CustomEvent("cart:build"));
      })
      .catch((error) => console.log(error));
  });

  // slide arrow

  let imageWarpper = document.querySelector(".images-product-wrapper");
  let allpaginations = document.querySelectorAll(
    ".swiper-pagination .swiper-pagination-bullet"
  );
  let zoomimg = document.querySelector(".products-images img:first-child");

  // Only add event listeners if elements exist
  if (imageWarpper) {
    imageWarpper.addEventListener("click", function (e) {
      let next = e.target.closest(".flex-next");
      if (!next) return;
      let currPagination = document.querySelector(
        ".swiper-pagination .swiper-pagination-bullet-active"
      );
      let nextPagination = currPagination.nextElementSibling;
      if (!nextPagination) return;
      nextPagination.click();
    });

    imageWarpper.addEventListener("click", function (e) {
      let prev = e.target.closest(".flex-prev");
      if (!prev) return;
      let currPagination = document.querySelector(
        ".swiper-pagination .swiper-pagination-bullet-active"
      );
      let prevPagination = currPagination.previousElementSibling;
      if (!prevPagination) return;
      prevPagination.click();
    });
    
    imageWarpper.addEventListener("click", function (e) {
      let zoom = e.target.closest(".imzoom");
      if (!zoom) return;
      if (zoomimg) zoomimg.click();
    });
  }

  // sku code
  const swatchEl = document.querySelectorAll(".swatch-element");
  const allSku = document.querySelectorAll(".all-skus");
  const allSkuname = document.querySelectorAll(".sku-name");
  let swatchWrapper = document.querySelector(".swatch-items-wrapper");
  let getthnotify = document.querySelector(
    "#shopify-block-pw_stock_notify_app_block_DMPFkQ"
  );
  let swatchWrappergrp = document.querySelector(
    ".swatch-items-wrapper .swatch-element input:checked"
  );
  let paymentButtonsWrapperonload = document.querySelector(".form-vertical");
  // console.log(paymentButtonsWrapperonload,'paymentButtonsWrapperonload')
  let getaddtocart = document.querySelector("#AddToCart");
  var onloadnotifyDiv = document.querySelector(".form-vertical");

  if (!swatchWrappergrp) return;

  allSku.forEach((s) => s.classList.remove("current-sku"));
  allSkuname.forEach((s) => s.classList.add("hidden-skuname"));

  document
    .querySelector(`.active-sku--${swatchWrappergrp.dataset.varinatsku}`)
    .classList.add("current-sku");
  document
    .querySelector(`.active-sku--name--${swatchWrappergrp.dataset.varinatsku}`)
    .classList.remove("hidden-skuname");

  swatchWrapper.addEventListener("click", function (e) {
    let currentSwatch = e.target.closest(".swatch-element input");
    let currentSwatchEle = e.target.closest(".swatch-element");
    if (currentSwatchEle?.classList.contains("soldout")) {
      if (getthnotify) {
        onloadnotifyDiv.appendChild(getthnotify);
      }
    } else if (currentSwatchEle.classList.contains("available")) {
      if (getthnotify) {
        getthnotify.remove();
      }
    }

    if (!currentSwatch) return;
    allSku.forEach((s) => s.classList.remove("current-sku"));
    allSkuname.forEach((s) => s.classList.add("hidden-skuname"));

    document
      .querySelector(`.active-sku--${currentSwatch.dataset.varinatsku}`)
      .classList.add("current-sku");
    document
      .querySelector(`.active-sku--name--${currentSwatch.dataset.varinatsku}`)
      .classList.remove("hidden-skuname");

    document
      .querySelector(`.active-sku--${currentSwatch.dataset.varinatsku}`)
      .classList.add("current-sku");
    document
      .querySelector(`.active-sku--name--${currentSwatch.dataset.varinatsku}`)
      .classList.remove("hidden-skuname");

    // Check SKU disclaimer when swatch changes
    if (currentSwatch.dataset.varinatsku) {
      checkSkuDisclaimer(currentSwatch.dataset.varinatsku);
    }
  });

  const skudisclaimer = [
    "270226",
    "270222",
    "271242",
    "270542",
    "271215",
    "271340",
    "270515",
    "270005",
    "271213",
    "270513",
    "270003",
    "271216",
    "272016",
    "271217",
    "270517",
    "273017",
    "272017",
    "270518",
    "272018",
    "265010",
    "271674",
    "260523",
    "270735",
    "270725",
    "270745",
    "270216",
    "270215",
    "270266",
    "270271",
    "390335",
    "969329",
    "2204159",
    "270256",
    "270238",
    "270246",
    "352777",
    "161012",
    "160516",
    "270005",
    "274040",
  ];
  const checkBox = document.querySelector(".checkbox-wrapper");

  // Function to check SKU disclaimer
  function checkSkuDisclaimer(skuValue) {
    if (!checkBox) {
      console.log('Checkbox wrapper not found for SKU disclaimer');
      return;
    }
    
    if (skudisclaimer.includes(skuValue)) {
      checkBox.style.display = "block";
    } else {
      checkBox.style.display = "none";
    }
  }

  // Check initial SKU on page load
  if (swatchWrappergrp && swatchWrappergrp.dataset.varinatsku) {
    checkSkuDisclaimer(swatchWrappergrp.dataset.varinatsku);
  }

  let pailProduct = document.querySelector(
    '.js-qty[data-qty="pail-with-lid-5-gal-white"]'
  );
  let input = document.querySelector(
    '.js-qty[data-qty="pail-with-lid-5-gal-white"] input'
  );

  if (pailProduct) {
    pailProduct.querySelector("input").value = 2;
  }

  pailProduct?.addEventListener("click", function (e) {
    let minus = e.target.closest(
      '.js-qty[data-qty="pail-with-lid-5-gal-white"] .js-qty__adjust--minus'
    );
    if (!minus) return;
    pailProduct.querySelector("input").value =
      Number(pailProduct.querySelector("input").value) != 2
        ? Number(pailProduct.querySelector("input").value) - 2
        : 2;
  });

  pailProduct?.addEventListener("click", function (e) {
    let plus = e.target.closest(
      '.js-qty[data-qty="pail-with-lid-5-gal-white"] .js-qty__adjust--plus'
    );
    if (!plus) return;
    let inputBox = pailProduct.querySelector(
      '.js-qty[data-qty="pail-with-lid-5-gal-white"] input'
    );
    inputBox.value = Number(inputBox.value) + 2;
  });

  input?.addEventListener("change", function () {
    let evenNo = convertToEvenNumber(this.value * 1);
    if (evenNo < 0) {
      this.value = evenNo;
    } else {
      this.value = 2;
    }
  });

  const convertToEvenNumber = function (no) {
    let evenNo = no % 2 != 0 ? no + 1 : no;
    return evenNo;
  };
});

document.addEventListener('DOMContentLoaded', function() {
    const popupOpen = document.getElementById('pw_notify_popup_open');
    if (popupOpen) {
        popupOpen.addEventListener('click', function() {
            const popup = document.getElementById('mypw_model_popup');
            if (popup) {
                popup.style.display = 'flex';
            }
        });
    }
});


